// extracted by mini-css-extract-plugin
export default {"root":"finecoFundManagerInfoArtifact_root__U0-R8","note":"finecoFundManagerInfoArtifact_note__APo12"};